import React from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const SizeOriginalIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    width: "16",
    height: "12",
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.5 0H1.5C1.10218 0 0.720644 0.158035 0.43934 0.43934C0.158035 0.720644 0 1.10218 0 1.5V10.5C0 10.8978 0.158035 11.2794 0.43934 11.5607C0.720644 11.842 1.10218 12 1.5 12H14.5C14.8978 12 15.2794 11.842 15.5607 11.5607C15.842 11.2794 16 10.8978 16 10.5V1.5C16 1.10218 15.842 0.720644 15.5607 0.43934C15.2794 0.158035 14.8978 0 14.5 0ZM15 10.5C15 10.6326 14.9473 10.7598 14.8536 10.8536C14.7598 10.9473 14.6326 11 14.5 11H1.5C1.36739 11 1.24021 10.9473 1.14645 10.8536C1.05268 10.7598 1 10.6326 1 10.5V1.5C1 1.36739 1.05268 1.24021 1.14645 1.14645C1.24021 1.05268 1.36739 1 1.5 1H14.5C14.6326 1 14.7598 1.05268 14.8536 1.14645C14.9473 1.24021 15 1.36739 15 1.5V10.5ZM7.89003 6.69043C7.71473 6.69081 7.54635 6.75888 7.42003 6.88043C7.35697 6.93932 7.30668 7.01054 7.27227 7.08967C7.23787 7.1688 7.22009 7.25415 7.22003 7.34043C7.21885 7.4269 7.23608 7.51263 7.27056 7.59194C7.30504 7.67124 7.35599 7.74231 7.42003 7.80043C7.54657 7.92146 7.71492 7.989 7.89003 7.989C8.06513 7.989 8.23348 7.92146 8.36003 7.80043C8.42276 7.74181 8.47219 7.67042 8.50497 7.59106C8.53775 7.5117 8.55311 7.42623 8.55003 7.34043C8.55185 7.25479 8.53591 7.1697 8.50321 7.09053C8.47051 7.01136 8.42175 6.93982 8.36003 6.88043C8.23371 6.75888 8.06533 6.69081 7.89003 6.69043ZM7.63541 4.04665C7.71623 4.01398 7.80288 3.99816 7.89003 4.00017C7.97718 3.99816 8.06382 4.01398 8.14464 4.04665C8.22546 4.07932 8.29875 4.12816 8.36003 4.19017C8.42276 4.24879 8.47219 4.32018 8.50497 4.39954C8.53775 4.4789 8.55311 4.56436 8.55003 4.65017C8.55185 4.73581 8.53591 4.8209 8.50321 4.90007C8.47051 4.97924 8.42175 5.05078 8.36003 5.11017C8.23348 5.2312 8.06513 5.29874 7.89003 5.29874C7.71492 5.29874 7.54657 5.2312 7.42003 5.11017C7.35697 5.05128 7.30668 4.98006 7.27227 4.90093C7.23787 4.8218 7.22009 4.73645 7.22003 4.65017C7.21885 4.5637 7.23608 4.47797 7.27056 4.39866C7.30504 4.31936 7.35599 4.24829 7.42003 4.19017C7.4813 4.12816 7.55459 4.07932 7.63541 4.04665ZM3 4.15965V5.23965L4.44 4.27965V8.85965H5.51V3.13965H4.6L3 4.15965ZM9.98999 5.23965V4.15965L11.59 3.13965H12.5V8.85965H11.42V4.27965L9.98999 5.23965Z",
      fill: "currentColor"
    }
  )
);

export { SizeOriginalIcon as default };
//# sourceMappingURL=SizeOriginalIcon.js.map
